<template>
	<AppLayout
		:title="trans('admin.users.representatives.certificates.create.title', {years: group.years})"
		:return-url="route('association.representatives.certificates.index')"
		:return-label="trans('admin.users.representatives.certificates.title')"
	>
		<template #actions>
			<StoreCertificate
				certifiable-type="boardRepresentativeGroup"
				:certifiable-id="group.id"
				:return-label="trans('admin.users.representatives.certificates.create.title', {years: group.years})"
				:return-url="route('association.representatives.certificates.show', group.id)"
			/>
		</template>
		<CertificatesManager
			:return-label="trans('admin.users.representatives.certificates.create.title', {years: group.years})"
			:return-url="route('association.representatives.certificates.show', group.id)"
			:certificates="certificates"
		/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {ref, type Ref, defineProps} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import {type Certificate} from '@/Types/Certificates/Certificate'
import StoreCertificate from '@/Components/Certificates/StoreCertificate.vue'
import CertificatesManager from '@/Components/Certificates/CertificatesManager.vue'
import {type BoardRepresentativeGroup} from '@/Types/Association/Representatives/BoardRepresentativeGroup'

const props = defineProps<{
	group:BoardRepresentativeGroup,
	certificates:Array<Certificate>,
}>()

const group:Ref<BoardRepresentativeGroup> = ref(props.group)
const certificates:Ref<Array<Certificate>> = ref(props.certificates)
</script>